var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CourseManagement"},[_c('AppHeader',[_vm._v("课程管理")]),_c('AppBox',{staticClass:"appBox"},[_c('course-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }